import { render, staticRenderFns } from "./ComboSkuList.vue?vue&type=template&id=08a24a8c&scoped=true&"
import script from "./ComboSkuList.vue?vue&type=script&lang=js&"
export * from "./ComboSkuList.vue?vue&type=script&lang=js&"
import style0 from "./ComboSkuList.vue?vue&type=style&index=0&id=08a24a8c&scoped=true&lang=scss&"
import style1 from "./ComboSkuList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a24a8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow,VSimpleTable,VTextField,VTooltip})
